import { FilterModalTypes } from '../../../../../../components/FilterModal';
import { TableHeadItemRecurse } from '../../../../../../components/TableHead';

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Cliente', flex: 1.5 },
  { title: 'Ativo' },
  { title: 'Data inicio' },
  { title: 'Vencimento' },
  { title: 'Valor aplicado' },
  { title: 'Valor atual' },
  { title: 'Valor de marcação' },
  { title: 'Retorno' },
];

export const getCoesFilters = (): FilterModalTypes.FilterType[] => [];
